import { GroupEditItemsField } from 'pages/requestForm/containers/netsuite/hooks';
import {
    isFieldReadOnly,
    isFieldVisible,
} from 'pages/requestForm/containers/netsuite/NetSuiteRequestForm/NetSuiteRequestForm.helpers';
import { useNetSuiteExpenseReportExpenseLinesFieldSettings } from 'shared/hooks';

/**
 * Returns a list of available fields for group editing of expense report lines
 *
 * Filters through all possible group edit fields and returns only those that are:
 * - Visible to the user
 * - Not read-only
 */
export const getGroupEditItemsAvailableFields = (
    fieldSettings: ReturnType<typeof useNetSuiteExpenseReportExpenseLinesFieldSettings>
) => {
    return Object.values(GroupEditItemsField).reduce<GroupEditItemsField[]>((availableFields, field) => {
        const setting = fieldSettings[field as keyof typeof fieldSettings];

        if (isFieldVisible(setting) && !isFieldReadOnly(setting)) {
            availableFields.push(field);
        }

        return availableFields;
    }, []);
};
